module.exports = __webpack_public_path__ + "img/print.e2f8c4d9.svg";